/**
 * 和外链文件相关的公用
 * 检测file的能否预览
 * 发送外链的最近访问
 */
import { resolveFileAction } from 'js/util/util'

const { getData, postData } = require('js/api/getdata').default

export const LINKFILE = {
  data() {
    return {
      metaData: {}, // METADATA
    }
  },
  watch: {
  },
  methods: {
    /**
      * 外链的最近访问上报
      * @param { Object } 上报的外链信息
      */
    sendRecent(data) {
      try {
        if (this.data.ext && this.data.ext.islogin) { // 是否登录
          const deliveryInfo = { ...data }
          const param = { // 请求参
            neid: data.neid,
            nsid: data.nsid,
            fileType: 7,
            deliveryUrl: window.location.href,
            deliveryInfo: JSON.stringify(deliveryInfo),
          }
          Object.assign(param, { arrayFormat: true })
          postData('sendRecent', param)
        }
      } catch(e) {

      }
    },
    /**
         * 大小超限
         */
    async linkPreviewLimit() {
      let data = {}
      const param = {
        neid: this.metaData.neid,
        nsid: this.metaData.nsid,
      }
      try {
        data = (await getData('previewFileLimit', param)).data
      } catch (e) {
        data = {}
      }
      return data
    },
    /**
         * 是否有预览权限
         */
    accountSupport() {
      return /^preview/.test(resolveFileAction(this.metaData.access_mode))
    },
    /**
         * 不是体验版
         */
    nonTrialAccount() {
      return !this.metaData.is_trial
    },
    /**
         * 类型是否支持预览
         */
    typeSupport() {
      const mimeType = this.metaData.mime_type || ''
      if (this.metaData.support_preview == 'false') {
        return false
      }
      return true
    },
    /**
         * 检测是否支持预览
        * 检测大小和文件类型
        */
    async checkPreSupport() {
      const vm = this
      const checkMap = {
        typeSupport: {
          func: vm.typeSupport,
        },
        sizeSupport: {
          func: vm.linkPreviewLimit,
          async: true,
        },
        accountSupport: {
          func: vm.accountSupport,
        },
      }
      let type = '' // 哪种异常类型
      let extData = {} // 异常提示数据
      let label = true // 标志，是否通过check preview的验证
      for (const key in checkMap) {
        if (checkMap.hasOwnProperty(key)) {
          if (checkMap[key].async) {
            /* eslint-disable */
                        let res = await (checkMap[key].func).call(vm)
                        extData = res
                        if (!res.checkSizeResult && res.previewSizeLimit) { // 文件大小校验返回值
                            extData.maxSize = res.previewSizeLimit || 0;
                            label = res.checkSizeResult;
                        }
                    } else {
                        label = (checkMap[key].func).call(vm)
                    }
                    // 检测预览，有不通过的
                    if (!label) {
                        type = key;
                        return {
                            canPreview: type == '',
                            type: type,
                            extData: extData,
                        }
                    }
                }
            }
            return {
                canPreview: true,
                type: '',
                extData: {},
            }
        },
        /**
         * 显示异常页面
         */
        showAbornomal(data) {
            let cfg = {
                'accountSupport': 'invalidPreview', // 无权限预览
                // 'trialAccount': 'invalidDemo', // 体验版
                'typeSupport': 'notSupport', // 不支持预览类型
                'sizeSupport': 'oversize', // 超限
            }
            this.abnormalType = cfg[data.type]
            // 判断 extData是对象
            if (Object.prototype.toString.call(data.extData) == "[object Object]") {
                this.abnormalData = data.extData
            }
        },
    },
}
